import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useFormik } from "formik";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import FacebookLogin from "react-facebook-login";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom/dist";
import * as Yup from "yup";
import Loader from "../Commons/Loader/Loader";
import { isLogin } from "../Redux/LoginSlice";
import { LogUpApi, socialLogin } from "../Services/APIServices";
import {
  ClosedEyeGreyIcon,
  EyeGreyIcon,
  FacebookBlueIcon2,
  GooglePlusIcon,
  KeyGreyIcon,
  UserGreyIcon,
} from "../SvgIcons/allIcons";
import { FACEBOOK, GOOGLE, LENDER, RENTER } from "../globals/constants";

export default function Login({ handleShowTwo, handleClose }) {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    email: Yup.string()
      .email()
      .required("Email required")
      .max(70, "Maximum lenght is 70 characters.")
      .min(5, "Need at least 5 characters."),
    password: Yup.string()
      .min(6, "Password must be at least 8 characters.")
      .required("Password required"),
  });

  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    isSubmitting,
    handleBlur,
    touched,
    isValid,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit(values, { setSubmitting, resetForm }) {
      setSubmitting(true);
      let formData = new FormData();
      formData.append("email", values.email);
      formData.append("password", values.password);
      setLoading(true);
      LogUpApi(formData)
        .then((resp) => {
          setLoading(false);
          setSubmitting(false);
          if (resp?.status === 200) {
            dispatch(isLogin(resp?.data?.data));
            localStorage.setItem("token", resp?.data?.data?.token);
            localStorage.setItem(
              "userDetails",
              JSON.stringify(resp?.data?.data)
            );
            if (resp?.data?.data?.role_id == LENDER) {
              navigate("/lender/home");
            }
            if (resp?.data?.data?.role_id == RENTER) {
              navigate("/renter/home");
            }
            resetForm();
          }
        })
        .catch((err) => console.log(err));
    },
  });

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (isValid) {
        handleSubmit();
      }
    }
  };

  const responseFacebook = async (response) => {
    try {
      setLoading(true);
      let formData = new FormData();
      formData.append("email", response?.data?.email);
      formData.append("profile_pic", response?.data?.picture);
      formData.append("full_name", response?.data?.name);
      formData.append("social_id", response?.data?.sub);
      formData.append("social_type", FACEBOOK);

      let resp = await socialLogin(formData);

      if (resp?.status === 200) {
        setLoading(false);
        dispatch(isLogin(resp?.data?.data));
        localStorage.setItem("token", resp?.data?.data?.token);
        localStorage.setItem("userDetails", JSON.stringify(resp?.data?.data));
        if (resp?.data?.data?.role_id == LENDER) {
          navigate("/lender/home");
        }
        if (resp?.data?.data?.role_id == RENTER) {
          navigate("/renter/home");
        }
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      try {
        setLoading(true);
        const userInfo = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          { headers: { Authorization: `Bearer ${access_token}` } }
        );

        let formData = new FormData();
        formData.append("email", userInfo?.data?.email);
        formData.append("profile_pic", userInfo?.data?.picture);
        formData.append("full_name", userInfo?.data?.name);
        formData.append("social_id", userInfo?.data?.sub);
        formData.append("social_type", GOOGLE);

        let resp = await socialLogin(formData);

        if (resp?.status === 200) {
          setLoading(false);
          dispatch(isLogin(resp?.data?.data));
          localStorage.setItem("token", resp?.data?.data?.token);
          localStorage.setItem("userDetails", JSON.stringify(resp?.data?.data));
          if (resp?.data?.data?.role_id == LENDER) {
            navigate("/lender/home");
          }
          if (resp?.data?.data?.role_id == RENTER) {
            navigate("/renter/home");
          }
        }
      } catch (err) {
        console.log("err", err);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <Form>
        
        <Form.Group
          className="mb-3 position-relative"
          controlId="Form.ControlInput1"
        >
          <div className="user-icon">
            <UserGreyIcon />
          </div>
          <Form.Control
            type="email"
            name="email"
            value={values?.email}
            placeholder="Email"
            className="email"
            autoComplete="nope"
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
          />
          {touched?.email && errors?.email && (
            <span className="text-start required">{errors?.email}</span>
          )}
        </Form.Group>
        <Form.Group
          className="mb-3 position-relative"
          controlId="Form.ControlInput2"
        >
          <div className="key-icon">
            <KeyGreyIcon />
          </div>
          <Form.Control
            type={showPassword ? "text" : "password"}
            name="password"
            value={values?.password}
            placeholder="Password"
            className="password"
            autoComplete="off"
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
          />
          {touched?.password && errors?.password && (
            <span className="text-start required">{errors?.password}</span>
          )}
          <div
            className="eye-icon"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <EyeGreyIcon /> : <ClosedEyeGreyIcon />}
          </div>
        </Form.Group>
      </Form>
      <div className="d-flex align-items-center">
        <Button
          className="btn-theme loginbtn"
          disabled={isSubmitting || !isValid}
          onClick={handleSubmit}
        >
          Login
        </Button>
        <Link
          className="text-underline ms-lg-4 ms-md-4 ms-sm-2 mb-3"
          onClick={() => {
            handleClose();
            handleShowTwo();
          }}
        >
          Forgot Password?
        </Link>
      </div>
      <h5>OR</h5>
      {/* <FacebookLogin
        appId={process.env.REACT_APP_FACEBOOK_APP_ID}
        fields="name,email,picture"
        callback={responseFacebook}
        cssclassName="btn-facebook"
        textButton=""
        icon={
          <>
            <FacebookBlueIcon2 /> <span>Continue with Facebook</span>
          </>
        }
      /> */}
      <Link className="btn w-100 btn-social mt-2" onClick={() => googleLogin()}>
        <GooglePlusIcon />
        Continue with Google
      </Link>

      {loading ? <Loader /> : null}
    </>
  );
}
